import { Button } from '@vrplatform/components';
import {
  usePartnerRegion,
  useTeam,
  useTeamPermission,
  useTeamRole,
} from '@vrplatform/data';
import { Center, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router';
import { useAddTeamDrawer } from '../../../../drawers/add-team-drawer/useAddTeamDrawer';

export const DashboardManagedTeamRegionsWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [{ type }] = useTeam();
  const { managedTeamRegions } = usePartnerRegion();
  const { isPartnerAdmin, isVrpAdmin } = useTeamRole();
  const canManagePartnerMemberships = useTeamPermission(
    'partner-memberships:manage'
  );
  const { pathname } = useLocation();
  const { open: openAddTeamDrawer } = useAddTeamDrawer();

  if (
    type !== 'partner' ||
    managedTeamRegions.length > 0 ||
    pathname.startsWith('/members') ||
    pathname.startsWith('/settings') ||
    pathname.startsWith('/features')
  ) {
    return children;
  }

  // Provisioning a team creates a partner-managed membership. The platform
  // admin branch is kept: `isVrpAdmin` is not a team permission, and inventing
  // one for it would grant or deny access by accident.
  const canCreateTeam =
    isVrpAdmin || (isPartnerAdmin && canManagePartnerMemberships);

  return (
    <Center mih="70dvh" px="md">
      <Stack align="center" gap="sm" maw={560} ta="center">
        <Title order={2} c="neutral">
          No managed team regions yet
        </Title>
        <Text component="p" c="gray">
          {canCreateTeam
            ? 'Create a team to start managing regional team data.'
            : 'This partner does not manage any team regions yet. Ask a partner administrator to create a team.'}
        </Text>
        {canCreateTeam && (
          <Button
            variant="primary"
            leftIcon="PlusIcon"
            onClick={() => openAddTeamDrawer()}
          >
            Create team
          </Button>
        )}
      </Stack>
    </Center>
  );
};
